import React from 'react';
import { ComponentMeta, ComponentStory } from '@storybook/react';

import Text from './Text';

export default {
  title: 'Text',
  component: Text,
} as ComponentMeta<typeof Text>;

const Template: ComponentStory<typeof Text> = args => (
  <div style={{ width: '500px' }}>
    <Text {...args} />
  </div>
);

const text =
  'The sun dipped below the horizon, casting hues of orange and pink across the sky. A gentle breeze rustled through the trees, carrying with it the scent of freshly cut grass. Birds chirped their evening songs, signaling the transition from day to night.';
const commonProps = {
  children: text,
};

export const Basic = Template.bind({});
Basic.args = {
  ...commonProps,
};
